module.exports = __webpack_public_path__ + "img/about.7779d271.png";